/** @jsxImportSource @emotion/react */
import React from "react";
import { colors } from "./colors";
import { css } from "@emotion/react";

const barStyle = css`
  display: flex;
  flex-direction: row;
  position: sticky;
  padding-left: 0px;
  padding-right: 0px;
  bottom: 0;
  width: 100%;
  z-index: 1000;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  border-top: 1px solid ${colors.ctaInactive};
`;

export const StickyBottomBar = ({
  children,
  ...rest
}: React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div css={barStyle} {...rest}>
      {children}
    </div>
  );
};
